module.exports = __webpack_public_path__ + "static/media/prequal.a295e4d4.png";